"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _wbmFormatMoney = require("wbm-format-money");
var _excluded = ["cartItem", "itemTotal", "discountTotal", "useMobile"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CartItemChild = function CartItemChild(_ref) {
  var cartItem = _ref.cartItem,
    itemTotal = _ref.itemTotal,
    discountTotal = _ref.discountTotal,
    useMobile = _ref.useMobile,
    props = _objectWithoutProperties(_ref, _excluded);
  var calculateKitQty = function calculateKitQty() {
    var qty = cartItem.qty;
    var kitItemQty = cartItem.kitItemQty;
    var originalComponentQuantity = qty / kitItemQty;
    return originalComponentQuantity * cartItem.submittedKitQty;
  };
  var kitItemPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: itemTotal,
    useCurrencySign: true
  });
  var discountPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: discountTotal,
    useCurrencySign: true
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters wbmcid-item no-border"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-item-details-container pl-0" + (useMobile ? " use-mobile" : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-item-details-heading"
  }, cartItem.brandName, " ", cartItem.description), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-text-gray"
  }, cartItem.itemIdentifier.id, cartItem.itemIdentifier.couponOfferCode)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-item-image-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-text-gray text-center pt-0"
  }, "QTY: ", cartItem.submittedKitQty ? calculateKitQty() : cartItem.qty)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-item-pricing-container"
  }, /*#__PURE__*/_react["default"].createElement("b", {
    className: discountTotal >= 0 ? "wbmcid-cross-out" : ""
  }, kitItemPrice), discountTotal >= 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-weight-bold wbmcid-text-red"
  }, discountPrice) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "wbmcid-text-gray"
  }, "$", cartItem.sellPrice.toFixed(2), " /", " ", cartItem.itemIdentifier.unitId.toUpperCase()))));
};
var _default = exports["default"] = CartItemChild;
//# sourceMappingURL=cartItemChild.js.map